import { read } from '@/api/rest';

const profileInformation = {
  index: async (options) => await read('/profile-information?' + options.toString()),
  view: async (id) => await read('/profile-information/' + id),
};

export default profileInformation;
